import { createFileRoute } from '@tanstack/react-router';
import { UnderConstruction } from '@/shared/components/UnderConstruction';

export const Route = createFileRoute('/_backoffice/collections/')({
    component: () => (
        <UnderConstruction title="Home" hint="Home del cobrador (agenda del día) — próximamente." />
    ),
});
